module.exports = __webpack_public_path__ + "static/img/8051_phase_function_Paper_Points.fb98879.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8051_phase_function_Paper_Points.png
// module id = xNe9
// module chunks = 0